import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

let uidSeq = 0

/**
 * Τοπικό μοναδικό id για client-side λίστες (π.χ. πόρτες στον wizard).
 *
 * Το `crypto.randomUUID()` είναι διαθέσιμο ΜΟΝΟ σε secure context — https://
 * ή localhost. Σε deployment τύπου http://192.168.1.50 (LAN, ακριβώς το
 * σενάριο αυτής της εφαρμογής) είναι undefined και η κλήση πετάει TypeError.
 */
export function uid(): string {
  const c = globalThis.crypto
  if (typeof c?.randomUUID === "function") return c.randomUUID()
  return `id-${Date.now().toString(36)}-${(uidSeq++).toString(36)}`
}

/**
 * Ελληνική κλίση ενικού/πληθυντικού με τον αριθμό μπροστά.
 *
 * ΓΙΑΤΙ ΒΟΗΘΟΣ ΚΑΙ ΟΧΙ ΤΕΡΝΑΡΙΟ ΣΤΗ ΘΕΣΗ ΤΟΥ: το «1 πόρτες» εμφανιζόταν σε
 * ΤΕΣΣΕΡΑ σημεία — πίνακας παραγωγής, αρχική, λίστα παραγγελιών, καρτέλα
 * πελάτη — και σε καθένα γραφόταν χωριστά. Ο ίδιος κανόνας γραμμένος
 * τέσσερις φορές διορθώνεται τρεις.
 */
export function plural(n: number, one: string, many: string): string {
  return `${n} ${n === 1 ? one : many}`
}
